import React, { useEffect,  useState } from "react";
// import ScrollToTop from "react-scroll-to-top";
import WhatsAppWidget from "react-whatsapp-chat-widget";
import "./App.css";

import Headerr from "./components/Navigation/Header";
import Layout from "./pages/Layout";
// import ownImage from "./assets/own.png";
import "react-whatsapp-chat-widget/index.css";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Header from './components/Header'
import { motion,} from 'framer-motion';
import ParticlesComponent from "./components/particles/particles";
// import img from './assets/devshakilh/devshakilh.png'
// import Typewriter from 'typewriter-effect';
import Aos from "aos";
import Preloader from './Preloader'
import { AnimatePresence } from 'framer-motion';

import ToTop from "./components/ToTop/ToTop";


import Paralax from "./components/Paralax/Paralax";
import BackgroundVideo from "./components/BackgroundVideo";
import { AudioToggle } from "./components/HomePageAudio/HomePageAudio";



function App() {

// header show 
const [showHeader, setShowHeader] = useState(true);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleScroll = () => {
    const currentScrollPos = window.pageYOffset;
    const show = currentScrollPos > 250; // Change this value as needed
    setShowHeader(show);
  };


 

 // Disable right-click
//  useEffect(() => {
//   const disableRightClick = (e) => {
//     e.preventDefault();
//   };

//   document.addEventListener('contextmenu', disableRightClick);

//   return () => {
//     document.removeEventListener('contextmenu', disableRightClick);
//   };
// }, []);


// Disable F12, Ctrl + Shift + I, Ctrl + Shift + J, Ctrl + U
const handleKeyDown = (e) => {
  if (
    e.keyCode === 123 ||
    (e.ctrlKey && e.shiftKey && e.key === 'I') ||
    (e.ctrlKey && e.shiftKey && e.key === 'J') ||
    (e.ctrlKey && e.key === 'C') ||
    (e.ctrlKey && e.key === 'U')
  ) {
    e.preventDefault();
  }
};

useEffect(() => {
  document.addEventListener('keydown', handleKeyDown);

  return () => {
    document.removeEventListener('keydown', handleKeyDown);
  };
}, []);
 

    const [isLoading, setIsLoading] = useState(true);

    useEffect( () => {
      (
        async () => {
            const LocomotiveScroll = (await import('locomotive-scroll')).default
            const locomotiveScroll = new LocomotiveScroll();
  
            setTimeout( () => {
              setIsLoading(false);
              document.body.style.cursor = 'default'
              window.scrollTo(0,0);
            }, 2000)
        }
      )()
    }, [])




    useEffect(() => {
        Aos.init({ duration: 1000 });
    }, []);


   

    const [mousePosition, setMousePosition] = useState({
        x: 0,
        y: 0
      });
      const [cursorVariant, setCursorVariant] = useState("default");
    
    
      useEffect(() => {
        const mouseMove = e => {
          setMousePosition({
            x: e.clientX,
            y: e.clientY
          })
        }
    
        window.addEventListener("mousemove", mouseMove);
    
        return () => {
          window.removeEventListener("mousemove", mouseMove);
        }
      }, []);
    
      const variants = {
        default: {
          x: mousePosition.x - 16,
          y: mousePosition.y - 16,
        },
        text: {
          height: 150,
          width: 150,
          x: mousePosition.x - 75,
          y: mousePosition.y - 75,
          backgroundColor: "yellow",
          mixBlendMode: "difference"
        }
      }
    
      const textEnter = () => setCursorVariant("text");
      const textLeave = () => setCursorVariant("default");


    return (
        <div className="disable-selection">


            {/* <PreLoading /> */}
            <AnimatePresence mode='wait'>
        {isLoading && <Preloader />}
      </AnimatePresence>
<BackgroundVideo/>
            <div className="App ">
           {/* <Navigation /> */}
<div  className=" bg[#FFFFFF]  lg:-mb-20">


<div className="hidden lg:block">
{showHeader && (
        <Header  />
      )}
</div>
   
<div className="lg:hidden"> 
<Header  />
</div>

<Headerr/>

</div>


<Paralax  />
    

            <div>
          
<ToTop/>
<div >
<motion.div    >









</motion.div>

</div>

<ParticlesComponent/>




<div class="relative h-full w-full bg-slate-950">
  <div class="absolute bottom-0 left-[-20%] right-0 top-[-10%] h-[500px] w-[500px] rounded-full bg-[radial-gradient(circle_farthest-side,rgba(255,0,182,.15),rgba(255,255,255,0))]">
    </div>
    
    <div class="absolute bottom-0 right-[-20%] top-[-10%] h-[500px] w-[500px] rounded-full bg-[radial-gradient(circle_farthest-side,rgba(255,0,182,.15),rgba(255,255,255,0))]">
      </div>
      
      </div>






</div>


      <motion.div
        className='cursor'
        variants={variants}
        animate={cursorVariant}
      />
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                />
              
              
                <div className="  mx-auto ">
                    <Layout />
                    
                </div>

               
           
                {/* <ScrollToTop
                    smooth
                    style={{
                        boxShadow: "0px 5px 10px 0px rgba(0, 255, 255, 0.7 ",
                        borderRadius: "50%",

                        right: 30,
                        bottom: 100,
                        // border:"1px solid #00C0FF"
                    }}
                    color="#00C0FF"
                    viewBox="0 0 160 256"
               
                /> */}
              <div className="hidden lg:block">
              <WhatsAppWidget
                    headerIcon="https://i.ibb.co/rMcPPyz/boy-1.png"
                    companyName="Md Shakil Hossain"
                    chatMessage="Hello! 👋🏼 welcome. How can I assist you?"
                    phoneNo="+8801728178063"
                    autoOpenTimer={0}
                
                    cursor="pointer"
                    iconColor="#141516"
                    chatPersonName="Md Shakil Hossain"
                    position="right"
                    style={{ border: "none",  cursor: "pointer", }}
                    
                />
              </div>
            </div>
        </div>
    );
}

export default App;
